import { modalActions } from '@/actions';
import { Button } from '@/components/elements/forms/buttons';
import { ListItem, ListItemContent } from '@/components/elements/lists';
import Icon from '@/components/icons/Icon';
import { useAppDispatch } from '@/hooks';
import { _s } from '@/locale';
import { useHistory } from 'react-router-dom';
import Modal from './redesign/Modal/Modal';

const baseTranslationKey = 'components.modules.modals.LastMinuteModal';

const LastMinuteModal = ({ isOpen }: { isOpen?: boolean }) => {
  const dispatch = useAppDispatch();
  const history = useHistory();

  const handleCloseClick = () => {
    dispatch(modalActions.lastMinute({ show: false }));
    localStorage.setItem('closedLastMinute', 'true');
  };

  const handleBookClick = () => {
    dispatch(modalActions.lastMinute({ show: false }));
    localStorage.setItem('closedLastMinute', 'true');
    history.push('/sistaminuten');
  };

  return (
    <Modal isOpen={isOpen}>
      <Modal.Content classNames="bg-bg_notice" floating={true} contentMaxWidth={518} wrapperStyle={{ padding: '12px' }}>
        <div className="text-fg_primary pt-sm px-md flex w-full flex-col items-center text-xl">
          <div
            className={`absolute right-0 top-0 flex h-[162px] w-[162px] -translate-y-1/4 translate-x-1/4 items-center justify-center rounded-full bg-[#c89f0c10]`}>
            <Icon variant="party" color="fg_alwaysLight" size="lg" />
          </div>
          <h2 className="pb-xs">{_s(`${baseTranslationKey}.title`)}</h2>
          <p className="text-h-l text-center font-bold">{_s(`${baseTranslationKey}.description`)}</p>
          <ul className="gap-md py-xl flex flex-col">
            <ListItem verticalAlign="top" className="!py-[0]" leftPadding={false} leftSlot={<Icon variant="smt" />}>
              <ListItemContent subTitle={_s(`${baseTranslationKey}.list.item1`)} />
            </ListItem>
            <ListItem
              verticalAlign="top"
              className="!py-[0]"
              leftPadding={false}
              leftSlot={<Icon variant="calendar-event" />}>
              <ListItemContent subTitle={_s(`${baseTranslationKey}.list.item2`)} />
            </ListItem>
            <ListItem verticalAlign="top" className="!py-[0]" leftPadding={false} leftSlot={<Icon variant="account" />}>
              <ListItemContent subTitle={_s(`${baseTranslationKey}.list.item3`)} />
            </ListItem>
          </ul>
          <Button
            label={_s(`${baseTranslationKey}.cta`)}
            block
            size="lg"
            variant="lastMinute"
            onClick={handleBookClick}
          />
          <Button label={_s('close')} block size="lg" variant="link" onClick={handleCloseClick} />
        </div>
      </Modal.Content>
    </Modal>
  );
};

export default LastMinuteModal;
